import { motion } from 'framer-motion';
import styled from 'styled-components';

import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { SwitchProps } from './switch';

export function AnimatedSwitch({
  checked,
  size = 'md',
  isDisabled = false,
}: {
  checked: boolean;
  size?: SwitchProps['size'];
  isDisabled?: boolean;
}) {
  const isSmall = size === 'sm';
  const width = isSmall ? 28 : 36;
  const height = isSmall ? 16 : 20;
  return (
    <Svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      data-checked={checked}
      data-disabled={isDisabled}
      style={{ minWidth: width }}
    >
      <motion.circle
        variants={variantMap[size]}
        initial={checked ? 'on' : 'off'}
        animate={checked ? 'on' : 'off'}
      />
    </Svg>
  );
}

const variantMap = {
  sm: {
    off: { cy: 6, r: 4, cx: 6 },
    on: { cy: 6, r: 6, cx: 18 },
  },
  md: {
    off: { cy: 8, r: 6, cx: 8 },
    on: { cy: 8, r: 8, cx: 24 },
  },
} as const;

const Svg = styled.svg({
  outline: 'none',
  borderRadius: 9999,
  borderStyle: 'solid',
  borderWidth: pxToRem(2),
  backgroundColor: 'transparent',
  borderColor: theme.color.interactiveElementNeutral,
  transition: 'all 100ms linear',
  overflow: 'visible',

  '& circle': {
    fill: theme.color.interactiveElementNeutral,
  },

  '&[data-checked="true"]': {
    borderColor: theme.color.interactiveElementSelected,
    backgroundColor: theme.color.interactiveElementSelected,
  },

  '&[data-checked="true"] circle': {
    fill: theme.color.white100,
  },

  '&[data-disabled="false"]': {
    'button:hover &': {
      boxShadow: `0 0 0 ${pxToRem(4)} ${theme.color.border10}`,
      borderRadius: 9999,
    },

    'button:focus-visible &': {
      boxShadow: theme.shadow.focus,
      '--shadow-focus-width': pxToRem(2),
      '--shadow-focus-gap': 0,
      '--shadow-focus-color': theme.color.elementBlue100,
    },
  },
});
